export default {
  topMenu: {
    openSettings: 'Einstellungen',
    showAbout: 'Allgemeine Informationen',
    about: 'Über ORS',
    pinSidebar: 'Seitenleiste dauerhaft',
    settingsTooltip: 'Hier klicken um Einstellungen anzzupassen'
  }
}
